import { APP_ROUTES } from '@/config/constants';
import { FlyerDetails } from '@/pages';
import { css } from '@emotion/css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EmbeddedJarContainer } from '@/pages/EmbeddedJar/EmbeddedJar.container';

export const EmbedRoutes: React.FC = () => {
  return (
    <div className={styles.embed}>
      <div className={styles.wrapper}>
        <Routes>
          <Route path={APP_ROUTES.embeddedJar} element={<EmbeddedJarContainer />} />
          <Route path={APP_ROUTES.embeddedFlyerDetails} element={<FlyerDetails />} />
        </Routes>
      </div>
    </div>
  );
};

const styles = {
  embed: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
    @media screen {
      background: #fff;
    }
  `,
  wrapper: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @media screen {
      align-items: center;
    }
  `,
};

